export { external as default }; //util functions to be shared by all ad instances on the page 

var external = {
  debugMode: false
};
var internal = {
  googleServicesEnabled: false
};
external.constants = {
  defaultLyticsWaitTime: 9999,
  refreshTargetingKey: "refresh",
  refreshTargetingValue: "true",
  refreshDelaySeconds: 30
}; //one-time initialization logic for page

external.initialize = function (settings) {
  if (internal.alreadyInitialized) return;
  internal.alreadyInitialized = true;
  external.debugMode = !!GeneralMills.debugDoubleClickComponent || !!window.location.search.match(/debugDoubleClickComponent=true/i);
  external.debugMode && console.log("[DoubleClick] Initializing DoubleClick for page...");
  external.stopWatches = {};
  internal.initializeGoogleTagApi(settings);
  internal.enableGoogleServicesForPage(settings);

  if (settings.testMode) {
    external.internal = internal;
  }
};

external.createStopWatch = function (adContainerId) {
  if (external.stopWatches[adContainerId]) return external.stopWatches[adContainerId]; //creates a new stopwatch per ad

  external.stopWatches[adContainerId] = {
    adDisplayRequested: 0,
    adSlotRendered: 0,
    adLoaded: 0,
    lyticsDataRequested: 0,
    lyticsLoaded: 0
  };
  return external.stopWatches[adContainerId];
};

external.startTimer = function (adContainerId, stopWatchProperty) {
  if (!external.stopWatches[adContainerId]) {
    external.createStopWatch(adContainerId);
  } //start the timer for this ad's stopwatch field


  external.stopWatches[adContainerId][stopWatchProperty] = Date.now();
};

external.getTimeSpan = function (startTime, endTime) {
  return endTime - startTime; //timespan in number of milliseconds
}; // Original GAM opt-out, need to keep until Jan 2021


internal.userHasRestrictionCookie = function () {
  var name = "DoubleClickRestrictDataProcessing";
  var b = document.cookie.match('(^|[^;]+)\\s*' + name + '\\s*=\\s*([^;]+)');
  if (b && b.pop() === "1") return true;
  return false;
};

internal.initializeGoogleTagApi = function (settings) {
  window.googletag = window.googletag || {};
  window.googletag.cmd = window.googletag.cmd || [];
  window.googletag.cmd.push(function () {
    //disable initial load until each ad slot calls it's own refresh() to display: https://support.google.com/dfp_premium/answer/4578089#lazyloading
    window.googletag.pubads().disableInitialLoad();
    window.googletag.pubads().enableAsyncRendering(); //async rendering: https://support.google.com/dfp_premium/answer/183282
    // If user has opted out of personalization, set privacy restriction

    if (settings.PrivacyOptOut || internal.userHasRestrictionCookie()) googletag.pubads().setPrivacySettings({
      'restrictDataProcessing': true
    });
  });
  internal.subscribeToGoogleTagImpressionEvent();

  if (external.debugMode) {
    internal.subscribeToGoogleTagEvents();
  }
};

internal.enableGoogleServicesForPage = function (adSettings) {
  //only execute page-level calls once per page
  if (internal.googleServicesEnabled) return;
  internal.googleServicesEnabled = true; //set page-level settings prior to calling enableServices(): 
  //https://developers.google.com/doubleclick-gpt/common_implementation_mistakes#scenario-5-mis-ordering-calls-to-gpt

  window.googletag.cmd.push(function () {
    //page-level targeting values from metadata
    if (adSettings.relevantMetadata && adSettings.relevantMetadata.length > 0) window.googletag.pubads().setTargeting("keywords", adSettings.relevantMetadata);
    window.googletag.enableServices();
    external.debugMode && console.log("[DoubleClick] GPT services enabled for page.");
  });
};

internal.showTimingData = function (adSlot) {
  if (!adSlot) return;
  var adContainerId = adSlot.getSlotElementId();
  var adUnitPath = adSlot.getAdUnitPath();
  var adStopWatch = external.stopWatches[adContainerId];
  if (!adStopWatch) return;
  var adLoadTime = external.getTimeSpan(adStopWatch.adDisplayRequested, adStopWatch.adLoaded);
  var message = "[DoubleClick][GPT] Ad load complete(contents loaded): " + adUnitPath + "\r\nLoad Time(ms): " + adLoadTime;
  console.log(message);
};

internal.subscribeToGoogleTagEvents = function () {
  //Subscribe to GPT specific service events: https://developers.google.com/doubleclick-gpt/reference#googletagservice
  window.googletag.cmd.push(function () {
    //Fires when the pubads service renders (creative code is injected into slot).
    //This will occur before the creative's resources are fetched, so the creative may not be visible yet
    window.googletag.pubads().addEventListener("slotRenderEnded", function (event) {
      if (!event || !event.slot) return;
      var adUnitPath = event.slot.getAdUnitPath();

      if (event.isEmpty) {
        external.debugMode && console.log("[DoubleClick][GPT] No ad returned for unit: " + adUnitPath);
      }

      var adContainerId = event.slot.getSlotElementId();
      external.startTimer(adContainerId, "adSlotRendered");
      external.debugMode && console.log("[DoubleClick][GPT] Slot is ready(contents loading): " + adUnitPath);
    }); //Fires when the creative's iframe fires its load event

    window.googletag.pubads().addEventListener("slotOnload", function (event) {
      if (!event || !event.slot) return;
      var adContainerId = event.slot.getSlotElementId();
      external.startTimer(adContainerId, "adLoaded");
      external.debugMode && internal.showTimingData(event.slot);
    }); //Fires whenever the on-screen percentage of an ad slot's area changes

    window.googletag.pubads().addEventListener("slotVisibilityChanged", function (event) {
      if (!event || !event.slot) return;
      var adUnitPath = event.slot.getAdUnitPath();
      external.debugMode && console.log("[DoubleClick][GPT] Slot on-screen visibility changed to " + event.inViewPercentage + "%: " + adUnitPath);
    });
  });
}; // Wiring this up separately to allow spaced refresh of viewed ads


internal.subscribeToGoogleTagImpressionEvent = function () {
  window.googletag.cmd.push(function () {
    // Fires when an impression becomes viewable, according to Active View criteria
    window.googletag.pubads().addEventListener("impressionViewable", function (event) {
      if (!event || !event.slot) return;
      var adUnitPath = event.slot.getAdUnitPath();
      external.debugMode && console.log("[DoubleClick][GPT] Ad impression officially viewable: " + adUnitPath);
      var slot = event.slot;

      if (slot.getTargeting(external.constants.refreshTargetingKey).indexOf(external.constants.refreshTargetingValue) > -1) {
        external.debugMode && console.log("[DoubleClick][GPT] Refresh targeting detected, setting refresh timeout: " + adUnitPath);
        setTimeout(function () {
          external.debugMode && console.log("[DoubleClick][GPT] Ad refresh initiated: " + adUnitPath);
          googletag.pubads().refresh([slot]);
        }, external.constants.refreshDelaySeconds * 1000);
      }
    });
  });
};